"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagePartiallyAcceptedTimelineCard = exports.PageAcceptedTimelineCard = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DetailsLine_1 = require("./DetailsLine");
var styles = __importStar(require("./PageAcceptedTimelineCards.css"));
var PageAcceptedTimelineCard = function (_a) {
    var _b = _a.interactionEventData, eventType = _b.eventType, accepters = _b.accepters, backupHash = _b.backupHash, timeZone = _a.timeZone, openAuditTrailOverlay = _a.openAuditTrailOverlay;
    var vaultUrl = (0, inversify_react_1.useInjection)("vaultUrl");
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", align: "left" }, eventType),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: openAuditTrailOverlay, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "View audit trail")),
        accepters.map(function (accepter, index) {
            return (react_1.default.createElement("div", { key: index, className: styles.accepterContainer },
                react_1.default.createElement(Accepter, { accepterData: accepter, timeZone: timeZone })));
        }),
        react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Audit PDF", value: react_1.default.createElement(kaleidoscope_1.Link, { href: "".concat(vaultUrl).concat(backupHash, "-project.pdf"), target: "_blank" }, "Download audit PDF") })));
};
exports.PageAcceptedTimelineCard = PageAcceptedTimelineCard;
var PagePartiallyAcceptedTimelineCard = function (_a) {
    var interactionEventData = _a.interactionEventData, timeZone = _a.timeZone, headingButton = _a.headingButton;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5" }, interactionEventData.eventType),
            headingButton),
        react_1.default.createElement(Accepter, { accepterData: interactionEventData.accepter, timeZone: timeZone })));
};
exports.PagePartiallyAcceptedTimelineCard = PagePartiallyAcceptedTimelineCard;
var Accepter = function (_a) {
    var accepterData = _a.accepterData, timeZone = _a.timeZone;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
        react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Name", value: accepterData.name }),
        react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Email", value: accepterData.email }),
        !!accepterData.company && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Organization", value: accepterData.company }),
        !!accepterData.signatureUrl && (react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Signature", value: react_1.default.createElement("div", { className: styles.signatureContainer },
                react_1.default.createElement("img", { src: accepterData.signatureUrl })) })),
        react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Date", value: new Intl.DateTimeFormat(undefined, {
                dateStyle: "medium",
                timeStyle: "short",
                hourCycle: "h12",
                timeZone: timeZone,
            }).format(accepterData.acceptedAt) })));
};
